import { matchIsValidTel } from 'mui-tel-input'

/**
 *
 * @param {string} params.errorMessage - the error message to return if the phone number is invalid
 * @param {string} params.phoneNumber - the phone number to validate
 * @returns {string|null} - the error message if the phone number is invalid, null otherwise
 */
export const validatePhoneNumber = ({
  errorMessage = 'Invalid phone number',
  phoneNumber,
}) => {
  return phoneNumber === undefined ||
    !phoneNumber ||
    matchIsValidTel(phoneNumber)
    ? null
    : errorMessage
}
